







































































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal para autorizadores
 * @author          Leticia Beltran
 * @creationDate    13/08/2021
 */

import MembersLayout from "@/layouts/Members.layout.vue";
import i18nMessages from "./i18n/messages";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import dataTableInvoice from "@/components/DatatableInvoice/DatatableInvoiceListAuto.vue";
import GlobalMixin from "@/mixins/global";

export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    MembersLayout,
    dataTableInvoice,
  },
  data: () => ({
    moduleName: "SEARCH_INVOICE",

    person: "",
    personOptions: [] as any,
    search: "",
    folFacSearch: "",
    orderSearch: "",
    loadingPersons: false,
    params: "",
    descriptionLimit: 60,

    company: [],
    chooseCompany: "",
    loadingCompany: false,
    loading: false,

    date: [],
    menu: false,
  }),
  methods: {
    async getCompany() {
      dataService.getCompany().then((Response: ResponseData) => {
        this.company = Response.data.data[0];
      });
    },
    async getdata(val: any) {
      dataService
        .getAllProvider(0, 10, val)
        .then((Response: ResponseData) => {
          this.personOptions = Response.data.data[0].data[0];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
    filterFuncion(item: any, queryText: any, itemText: any) {
      return (
        item.userID.toLowerCase().includes(queryText.toLowerCase()) ||
        item.userName.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    filterSociedad(item: any, queryText: any, itemText: any) {
      return (
        item.empresaClave.toLowerCase().includes(queryText.toLowerCase()) ||
        item.empresaRazonSocial.toLowerCase().includes(queryText.toLowerCase())
      );
    },
  },
  watch: {
    search(val: string) {
      // Items have already been requested
      if (this.loading) return;
      this.loading = true;
      this.getdata(val);
    },
  },
  computed: {
    dateRangeTxt() {},
  },
  mounted() {
    this.getCompany();
  },
});
